import React, { useCallback } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { BrandFeedbackForm, BrandGoBack } from 'services/Branding/components'
import { BrandFormEnum } from 'services/Branding/types'

import type { TestSingleChoiceFormBrandType } from './testSingleChoiceTypes'

const TestSingleChoiceFormFeedback: TestSingleChoiceFormBrandType = (props) => {
  const { setForm } = props
  const handleGoBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottom bottomSpace gap sides>
        <BrandGoBack onClick={handleGoBack} />
        <BrandFeedbackForm {...props} />
      </Padding>
    </LayoutScroll>
  )
}

export default React.memo(TestSingleChoiceFormFeedback) as typeof TestSingleChoiceFormFeedback
